// src/hooks/useInterviewCounts.js
import { useState, useEffect } from "react";
import { dashboardService } from "../services/dashboardService";

export const useInterviewCounts = () => {
  const [interviewCount, setInterviewCount] = useState(0);
  const [scheduledTimes, setScheduledTimes] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await dashboardService.getInterviewCounts();
        setInterviewCount(data.total_interviews_count || 0);
        setScheduledTimes(data.interview_scheduled_times || []);
      } catch (err) {
        console.error("Error fetching interview count:", err);
      }
    };
    fetch();
  }, []);

  return { interviewCount, scheduledTimes };
};